import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Icon } from 'components/icon'
import { colors } from 'utils/colors'
import { BREAKPOINTS } from 'utils/styled'

export const STitleRow = styled.div`
  display: flex;
  width: 100%;
  margin: 2rem 0;
  align-items: center;
`

export const SActionButton = styled(Button)`
  @media ${BREAKPOINTS.MD.min} {
    margin-left: auto;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 1rem;
    width: 100%;
  }
`

export const SIcon = styled(Icon)`
  color: ${colors.blue[500]};

  width: 2rem;
  height: 2rem;

  @media ${BREAKPOINTS.MD.max} {
    width: 1.5rem;
    height: 1.5rem;
  }
`
